export { KuiOptionPanelModule } from './option-panel.module';

